import {Component, Inject, OnInit} from '@angular/core';
import {DataARLedgerListModel} from '../../models/data-ar-ledger-list.model';
import {DataArPaymentAuditModel} from '../../models/data-ar-payment-audit.model';
import {DataARPaymentDistribsListModel} from '../../models/data-ar-payment-distribs-list.model';
import {NoteDataModel} from '../../../../models/notes/note-data.model';
import {Router} from '@angular/router';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ARService} from '../../ar.service';
import {NotesService} from '../../../../services/notes.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Globals} from '../../../../globals';
import {TDOPrintService} from '../../../../services/print/tdoprint.service';
import {PrintCCReceiptModel} from '../../../../models/accountsReceivable/PrintCCReceipt.model';
import {ReportIDEnum} from '../../../../models/enum/report-ID-enum';
import {ConversionUtilities} from '../../../../utilities/conversion.utilities';
import {EnumARPaymentType} from '../../../../models/enum/enum-ar-payment-type';

@Component({
  selector: 'app-ar-payment-distributions',
  templateUrl: './ar-payment-distributions.component.html',
  styleUrls: ['./ar-payment-distributions.component.scss']
})
export class ArPaymentDistributionsComponent  implements OnInit{
  isLoading: boolean = false;
  creditLedgerItem: DataARLedgerListModel;
  creditPayment: DataArPaymentAuditModel;
  paymentDistributions: DataARPaymentDistribsListModel[] = [];

  enumARLedgerItemOriginTypeTransaction: string = '00000207-1000-0000-0000-000000000003';
  enumARLedgerItemOriginTypePatient: string = '00000207-1000-0000-0000-000000000002';
  enumARLedgerItemOriginTypeInsurance: string = '00000207-1000-0000-0000-000000000001';

  TZID: string = '';
  constructor(
    private readonly router: Router,
    public dialogRef: MatDialogRef<ArPaymentDistributionsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly arService: ARService,
    private readonly notesService: NotesService,
    private readonly snackBar: MatSnackBar,
    private readonly globals: Globals,
    private readonly printService: TDOPrintService
  ) { }

  ngOnInit(): void {
    this.creditLedgerItem = this.data.ledgerItem;
    this.init();
  }

  async init() {
    this.isLoading = true;
    const promises: any[] = [];
    promises.push(this.arService.getPaymentDistributionsForCreditLedgerItem(this.creditLedgerItem.LedgerID).toPromise());

    if (this.creditLedgerItem.enumARLedgerItemOriginTypeID === this.enumARLedgerItemOriginTypeInsurance) {
      promises.push(this.arService.getPaymentInsurance(this.creditLedgerItem.PaymetnID).toPromise());
    }
    else {
      promises.push(this.arService.getPayment(this.creditLedgerItem.PaymetnID).toPromise());
    }

    try {
      const results: any[] = await Promise.all(promises);
      this.paymentDistributions = results[0];
      this.creditPayment = results[1];

      this.isLoading = false;
    }
    catch (err) {
      console.log(err);
      this.createMessage('Something went wrong', 'Error');
      this.isLoading = false;
    }
  }

  close() {
    this.dialogRef.close();
  }

  createMessage(message, type) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top'
    });
  }

  convertUTCDatetoTimezone(date: Date, tz: string) {
    date = ConversionUtilities.getAdjustedTimezoneDate(date, tz);
    return date;
  }

  returnPaymentType(id: string) {
    if (EnumARPaymentType.Check === id) { return 'Check'; }
    else if (EnumARPaymentType.Cash === id) { return 'Cash'; }
    else if (EnumARPaymentType.CreditCard === id) { return 'Credit Card'; }
    else if (EnumARPaymentType.CreditCardOffline === id) { return 'Credit Card Offline'; }
    else if (EnumARPaymentType.InternalCredit === id) { return 'Internal Credit'; }
    else { return ''; }
  }
}
